module.exports = __webpack_public_path__ + "img/tr-lang.4fcc8d63.png";